import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetNotificationResponse } from '../entities/notifications.entities';
import { ApiQueryParams } from '@utils/api-query-params.type';

@Injectable()
export abstract class SuperAdminHomeServices {
  /**
   * All Customers
   */
  abstract getAllCustomers(): Observable<any>;

  /**
   * All Active Users
   */
  abstract getAllActiveUsers(): Observable<any>;

  /**
   * All Notifications
   */
  abstract getNotifications(
    query: ApiQueryParams
  ): Observable<GetNotificationResponse>;

  /**
   * Get Notifications Count
   */
  abstract getNotificationsCount(
    query: ApiQueryParams
  ): Observable<{ data: number }>;

  /**
   * Delete Notification
   */
  abstract markAsReadNotification(
    notificationId: string
  ): Observable<GetNotificationResponse>;
}
